import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import axios from 'axios';

// Shared axios instance for the nominator surface. Cookies are httponly on the
// server so we set withCredentials globally rather than sprinkle it into every
// call site.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const nominatorApi = axios.create({ baseURL: API, withCredentials: true });

const NominatorAuthContext = createContext(null);

export const useNominatorAuth = () => {
  const ctx = useContext(NominatorAuthContext);
  if (!ctx) throw new Error('useNominatorAuth must be used inside <NominatorAuthProvider>');
  return ctx;
};

export const NominatorAuthProvider = ({ children }) => {
  const [nominator, setNominator] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await nominatorApi.get('/nominator/me');
      setNominator(data);
      return data;
    } catch {
      setNominator(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = useCallback(async () => {
    try {
      await nominatorApi.post('/nominator/logout');
    } catch { /* ignore */ }
    setNominator(null);
  }, []);

  const value = useMemo(() => ({ nominator, loading, refresh, logout, setNominator }), [nominator, loading, refresh, logout]);
  return <NominatorAuthContext.Provider value={value}>{children}</NominatorAuthContext.Provider>;
};
